import { useEffect, useMemo, useState } from "react";
import { http } from "@/lib/api";

export const fmtDate = (d) => d.toISOString().slice(0, 10);

const startOfWeek = (d) => {
  const monday = new Date(d);
  monday.setDate(d.getDate() - ((d.getDay() + 6) % 7));
  monday.setHours(0, 0, 0, 0);
  return monday;
};

const addDays = (d, n) => { const r = new Date(d); r.setDate(d.getDate() + n); return r; };

const buildRange = (view, anchor) => {
  if (view === "daily") return { start: fmtDate(anchor), end: fmtDate(anchor), days: [new Date(anchor)] };
  if (view === "weekly") {
    const monday = startOfWeek(anchor);
    const days = Array.from({ length: 7 }, (_, i) => addDays(monday, i));
    return { start: fmtDate(days[0]), end: fmtDate(days[6]), days };
  }
  const last = new Date(anchor.getFullYear(), anchor.getMonth() + 1, 0);
  const days = [];
  let cursor = startOfWeek(new Date(anchor.getFullYear(), anchor.getMonth(), 1));
  while (cursor <= last || days.length % 7 !== 0) { days.push(cursor); cursor = addDays(cursor, 1); }
  return { start: fmtDate(days[0]), end: fmtDate(days[days.length - 1]), days };
};

const buildTitle = (view, anchor, range) => {
  if (view === "monthly") return anchor.toLocaleDateString("tr-TR", { month: "long", year: "numeric" });
  if (view === "daily") return anchor.toLocaleDateString("tr-TR", { day: "numeric", month: "long", year: "numeric", weekday: "long" });
  const first = range.days[0].toLocaleDateString("tr-TR", { day: "numeric", month: "short" });
  const last = range.days[6].toLocaleDateString("tr-TR", { day: "numeric", month: "short", year: "numeric" });
  return `${first} - ${last}`;
};

export const useCalendarData = () => {
  const [view, setView] = useState("weekly");
  const [anchor, setAnchor] = useState(new Date());
  const [jobs, setJobs] = useState([]);

  const range = useMemo(() => buildRange(view, anchor), [view, anchor]);

  useEffect(() => {
    http.get("/jobs", { params: { start: range.start, end: range.end } }).then(({ data }) => setJobs(data));
  }, [range.start, range.end]);

  const jobsByDate = useMemo(() => jobs.reduce((m, j) => {
    (m[j.date] = m[j.date] || []).push(j);
    return m;
  }, {}), [jobs]);

  const shift = (n) => {
    const d = new Date(anchor);
    if (view === "daily") d.setDate(d.getDate() + n);
    else if (view === "weekly") d.setDate(d.getDate() + n * 7);
    else d.setMonth(d.getMonth() + n);
    setAnchor(d);
  };

  return { view, setView, anchor, setAnchor, range, jobsByDate, shift, title: buildTitle(view, anchor, range) };
};
